import React from 'react';
import { Route, Switch } from 'react-router';
import cn from 'classnames';

import LINK from 'constants/link.const';
import { useCurrentSalonId } from 'providers/SalonBasicInfo.provider';
import { useTheme } from 'providers/Theme.provider';
import linkTo from 'utils/links/linkTo.util';

import Tracking from 'vouchers/tabs/Tracking';

import CN from './routes.module.scss';

const VouchersRoutes = () => {
  const { isDarkMode } = useTheme();
  const salonId = useCurrentSalonId();

  const link = linkTo({ pattern: LINK.vouchersTracking, params: { salonId } });

  const componentClasses = cn({
    [CN.component]: true,
    [CN.darkMode]: isDarkMode,
  });

  return (
    <div className={componentClasses}>
      <Switch>
        {/* // TODO: investigate do we still want to have a rout */}
        <Route exact path={link} component={Tracking} />
      </Switch>
    </div>
  );
};

export default VouchersRoutes;
